module.exports = __webpack_public_path__ + "img/mandala-den.978eb6e1.jpg";